
import React from 'react';

const scatter = 'https://static.bodyspec.com/at/0b/81/0b8148a57fc05969';
const tdee = 'https://static.bodyspec.com/at/18/23/1823497f1a3d9ed2';

import DynamicAsset from 'components/DynamicAsset';

import * as styles from './styles.module.scss';

export const Static = () => {
	return (
		<div>
			<h2>How to understand RMR</h2>
			<div>
				<p>
					RMR is how many calories your body burns at rest.
					It is only part of your total daily energy
					expenditure (TDEE), which means that you'll want
					to consider other factors, like exercise, before
					determining a healthy daily caloric intake for
					weight change programs.
				</p>
				<p>
					Metabolic testing machines provide the most accurate
					data (measured RMR). We can also estimate RMR
					using your DEXA data in a range of accepted
					formulas. These equations vary in approach and
					output, but provide a loose framework for
					understanding your RMR.
				</p>
			</div>
			<div className={styles.charts}>
				<DynamicAsset imageSrc={tdee} />
				<DynamicAsset imageSrc={scatter} />
			</div>
		</div>
	);
};
